import script from "./CombinedOrderSettingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinedOrderSettingModal.vue?vue&type=script&setup=true&lang=ts"

import "./CombinedOrderSettingModal.vue?vue&type=style&index=0&id=55b27897&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b27897"]])

export default __exports__